module.exports = __webpack_public_path__ + "static/media/sundaeswap-reverse-iso.684a60e7.webp";